import { Theme } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

const useStyles = {
  alert: (theme: Theme) => ({
    ...useSharedStyles.fullWidthContainer,
    backgroundColor: theme.palette.ui.surfaceContainerLow,
    border: 0,
    borderRadius: 0,
    '& .MuiAlert-message': {
      width: '100%',
      padding: 0,
      paddingX: 2,
      height: '31px',
    },
  }),
  locationIcon: (theme: Theme) => ({
    color: theme.palette.ui.ui05,
    display: 'block',
    fontSize: '16px',
  }),
  truncatedText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '280px',
  },
  changeButton: {
    textTransform: 'none',
    float: 'inline-end',
  },
  gridContainer: {
    alignItems: 'center',
  },
  addressGrid: {
    paddingLeft: 0.5,
  },
}

export default useStyles
